if ($('#footer').length) {
  $('#signature').html('Vytvořil Shoptet | Nakódoval <a href="https://www.shopcode.cz" target="_blank">Shopcode</a> | Design by Klára Drážná')
}